const state = {
  isUpdate: false,
}
const getters = {
  isUpdateData(state) {
    return state.isUpdate
  },
}
const mutations = {
  toggleUpdateData(state) {
    state.isUpdate = !state.isUpdate
  },
}
export default { state, getters, mutations }
